import { AxiosError } from 'axios';
import { EventBus } from '../../../event';
import { Tags } from '../../../web';
import { Interceptor, InterceptorRequestConfig, IResponse } from '../http.service';

export const RequestTimeoutOccured = Symbol('shared:request-timeout-occured');
export const TIMEOUT_ERROR_CODE = 'ECONNABORTED';
export function isRequestTimeouted(rejection: AxiosError): boolean {
    return !rejection?.response && rejection?.code === TIMEOUT_ERROR_CODE;
}

export function handleTimeoutRequestInterceptor(): Interceptor {
    return {
        request: (config: InterceptorRequestConfig) => {
            config.timeout = config.timeout || 30 * 1000;
        },
        responseError: (error: IResponse) => {
            if (isRequestTimeouted(error)) {
                if (error.config?.taggedUrl && !error.config.taggedUrl.hasTag(Tags.Suz) && !error.config.taggedUrl.hasTag(Tags.OmitMessage)) {
                    EventBus.emit(RequestTimeoutOccured);
                }
                error.response = {
                    data: error.code,
                    request: error.request,
                    config: error.config,
                    headers: {},
                    status: 408,
                    statusText: ''
                };
            }
        }
    };
}
